import { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errDetail } from "@/lib/api";
import { KINDS } from "./emailSettingsTypes";

export function EmailPreview({ kind, lang, setLang, version }: { kind: string; lang: "es" | "en"; setLang: (l: "es" | "en") => void; version: number }) {
  const [p, setP] = useState<{ subject: string; html: string } | null>(null);
  const [to, setTo] = useState("");
  const [sending, setSending] = useState(false);
  useEffect(() => {
    let live = true;
    api.post("/staff/email-settings/preview", { kind, lang }).then(({ data }) => live && setP(data)).catch(() => live && setP(null));
    return () => { live = false; };
  }, [kind, lang, version]);
  const sendTest = async () => {
    setSending(true);
    try { const { data } = await api.post("/staff/email-settings/test", { kind, lang, to }); toast.success(`Correo de prueba enviado a ${data.to}`); }
    catch (e) { const d = errDetail(e); toast.error(d === "email_failed" ? "No se pudo enviar el correo" : d === "invalid_email" ? "Correo inválido" : d); }
    finally { setSending(false); }
  };
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3" data-testid="email-preview">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-semibold text-[#0B192C]">Vista previa · {KINDS.find((k) => k[0] === kind)?.[1]}</p>
        <div className="flex gap-1">{(["es", "en"] as const).map((l) => <button key={l} onClick={() => setLang(l)} data-testid={`email-preview-lang-${l}`} className={`rounded-full px-3 py-1 text-xs font-semibold ${lang === l ? "bg-[#0B192C] text-white" : "border border-slate-200 text-slate-600"}`}>{l.toUpperCase()}</button>)}</div>
      </div>
      <p className="text-xs text-slate-500" data-testid="email-preview-subject">Asunto: <span className="font-medium text-slate-700">{p?.subject || "…"}</span></p>
      {p ? <iframe title="preview" srcDoc={p.html} sandbox="allow-same-origin" className="w-full h-[520px] rounded-md border border-slate-100 bg-slate-50" data-testid="email-preview-frame" /> : <div className="h-[520px] grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>}
      <p className="text-[11px] text-slate-400">La vista previa usa datos de ejemplo. Guarda los cambios para verlos reflejados aquí.</p>
      <div className="flex flex-wrap gap-2 items-center">
        <Input type="email" placeholder="Enviar prueba a… (vacío = mi correo)" value={to} onChange={(e) => setTo(e.target.value)} data-testid="email-test-to-input" className="flex-1 min-w-[200px]" />
        <button onClick={sendTest} disabled={sending} data-testid="email-test-send-btn" className="inline-flex items-center gap-2 rounded-lg bg-[#0B192C] px-4 py-2 text-sm font-semibold text-white disabled:opacity-60">{sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}Enviar prueba</button>
      </div>
    </div>
  );
}
